// components/section.js
import React, { useEffect, useMemo, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import News from "./News";
import Article from "./Article";
import Pages from "./Pages";
import Home from "./Home";
import { api } from "../lib/api";

export default function Section({ basePath = "", websiteId, sectionText, siteMeta }) {
  const [sections, setSections] = useState([]);
  const [state, setState] = useState({ loading: true, error: null });

  useEffect(() => {
    (async () => {
      try {
        const secs = await api.sectionsByWebsite(websiteId);
        setSections(secs || []);
        setState({ loading: false, error: null });
      } catch (e) {
        setState({ loading: false, error: e.message || "Network error" });
      }
    })();
  }, [websiteId]);

  const newsSection = useMemo(
    () => sections.find(s =>
      (s.slug || "").toLowerCase() === "nyheter" || (s.type || "").toLowerCase() === "news"),
    [sections]
  );

  const pagesSection = useMemo(
    () => sections.find(s =>
      (s.slug || "").toLowerCase() === "sidor" || (s.type || "").toLowerCase() === "pages"),
    [sections]
  );

  if (state.loading) return <div className="p-8">Laddar innehåll…</div>;
  if (state.error) return <div className="p-8 text-red-600">Fel: {state.error}</div>;

  return (
    <div className="min-h-screen flex flex-col">
      <Header path={basePath} sectionText={sectionText} data={{ sections, siteMeta }} />

      <main className="flex-1">
        <Routes>
          {/* HOME (index) */}
          <Route
            index
            element={
              <Home
                websiteId={websiteId}
                sections={sections}
                basePath={basePath}
                newsSection={newsSection}
              />
            }
          />

          {/* NEWS LIST + ARTICLE */}
          {newsSection && (
            <>
              <Route
                path="nyheter"
                element={<News websiteId={websiteId} section={newsSection} basePath={basePath} />}
              />
              <Route
                path="nyheter/:itemSlug"
                element={<Article websiteId={websiteId} section={newsSection} basePath={basePath} />}
              />
            </>
          )}

          {/* PAGES: /<basePath>/sidor/:pageSlug */}
          {pagesSection && (
            <Route
              path="sidor/:pageSlug"
              element={<Pages websiteId={websiteId} section={pagesSection} />}
            />
          )}
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
